import { Icon } from '../Icon'
import styled, { css } from 'styled-components'
import { contrastColor, overloadColor } from '../util/style'

interface WrapperProps {
  inline: boolean
  disabled: boolean
  width: string
  minWidth?: string
  maxWidth?: string
}
export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  display: ${props => (props.inline ? 'inline-block' : 'block')};

  width: ${props => props.width};
  min-width: ${props => props.minWidth};
  max-width: ${props => props.maxWidth};

  ${props =>
    props.disabled &&
    `
    filter: grayscale(1) opacity(0.8);
  `}
`

interface DisplayProps {
  open: boolean
  disabled: boolean

  color: string
  background: string
}
const Display = styled.div<DisplayProps>`
  display: grid;
  grid-template-columns: 1fr auto;

  border: ${props => props.theme.layout.defaultBorder};
  border-radius: ${props => props.theme.sizes.defaultBorderRadius};

  color: ${props => overloadColor(props.color)};
  background: ${props => overloadColor(props.background)};
  user-select: none;

  ${props =>
    props.open &&
    css`
      border-radius: ${props => props.theme.sizes.defaultBorderRadius}
        ${props => props.theme.sizes.defaultBorderRadius} 0 0;
      border-width: 1px 1px 0 1px;
    `}

  ${props =>
    props.disabled &&
    css`
      background-color: #f8f8f8;
    `}

  div.--select-display-inner {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 4px 4px 0;
  }
  span.--select-placeholder {
    margin-left: 4px;
    padding-bottom: 4px;
    font-size: 0.8rem;
    color: ${props => props.theme.colors.placeholder};
  }

  &:focus {
    outline: none;

    ${props =>
      !props.open &&
      !props.disabled &&
      css`
        border-color: ${props => props.theme.colors.primary};
      `}
  }
`
export const Clear = styled.div.attrs({
  role: 'button',
})`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 6px;
  padding: 4px;
  border-radius: 4px;

  color: ${props => props.theme.colors.gray5};
  background: ${props => props.theme.colors.gray9};
  font-size: 0.8em;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colors.gray6};
    background: ${props => props.theme.colors.gray8};
  }
`
export const SelectDisplay = styled(Display)<DisplayProps & { height: string }>`
  height: ${props => props.height};

  span.--select-display-selected {
    margin-left: 4px;
    padding-bottom: 4px;
    font-size: 0.8rem;
  }
`
export const SelectMultipleDisplay = styled(Display)<
  DisplayProps & { minHeight: string }
>`
  min-height: ${props => props.minHeight};
`

export const ArrowIcon = styled(Icon)`
  text-align: center;
  align-self: center;
  width: 32px;
  font-size: 0.8rem;
`

interface CurtainProps {
  color: string
  background: string
}
export const Curtain = styled.div<CurtainProps>`
  box-sizing: border-box;
  position: absolute;
  z-index: 4000;
  width: 100%;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;

  border: ${props => props.theme.layout.defaultBorder};
  border-width: 0 1px 1px 1px;
  border-radius: 0 0
    ${props =>
      `${props.theme.sizes.defaultBorderRadius} ${props.theme.sizes.defaultBorderRadius}`};
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.15);

  color: ${props => overloadColor(props.color)};
  background: ${props => overloadColor(props.background)};

  &:focus {
    outline: none;
  }

  div.--select-inner {
    width: 100%;
    max-height: 250px;
  }
`

interface CurtainOptionProps {
  disabled?: boolean
  active: boolean
}
export const CurtainOption = styled.div<CurtainOptionProps>`
  padding: 6px;
  font-size: 0.8rem;
  user-select: none;
  text-align: left;

  ${props =>
    !props.disabled &&
    css`
      &:hover {
        background: ${props.theme.colors.gray8};
      }
      ${props.active &&
      css`
        background: ${props.theme.colors.gray8};
      `}
    `}
`

interface SelectedOptionProps {
  color: string
}
export const SelectedOption = styled.div<SelectedOptionProps>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  font-size: 0.8rem;
  padding: 4px 8px;
  background: ${props => overloadColor(props.color)};
  border-radius: 8px;
  color: ${props => contrastColor(overloadColor(props.color))};
  user-select: none;

  &:not(:last-of-type) {
    margin-right: 6px;
  }
  i {
    transform: translateY(1px);
    margin-left: 4px;
    cursor: pointer;
  }
`

export const SearchWrapper = styled.div`
  position: relative;
  padding: 4px 8px;

  input {
    width: 100%;
    padding: 4px 4px 4px 22px;
    border: 0;
    border-radius: 2px;
    background-color: #f6f6f9;
    font-size: 0.8rem;

    &:focus,
    &:active {
      outline: none;
    }
  }
  &::before {
    content: '\f002';
    font-family: 'Font Awesome 5 Pro';
    font-size: 0.8rem;
    color: #889;

    position: absolute;
    top: calc(50% + 2px);
    left: 12px;
    transform: translateY(-50%);
  }
`
